import { render, staticRenderFns } from "./FishList.vue?vue&type=template&id=3d29eec7&"
import script from "./FishList.vue?vue&type=script&lang=ts&"
export * from "./FishList.vue?vue&type=script&lang=ts&"
import style0 from "./FishList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports